






























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { toStyleVal, isNumeric } from '@/utils';

@Component
export default class AxTabPanel extends Vue {
  active = 0;

  @Prop({ type: Array, default: () => [] })
  value!: string[];

  @Prop({ type: String, default: null })
  width!: string;

  @Prop({ type: String, default: null })
  height!: string;

  @Prop({ type: String, default: 'rgba(0,0,0,0.25)' })
  color!: string;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  click(idx: number) {
    this.active = idx;
  }

  get styleVal() {
    const color = this.color !== '' ? this.color : '';
    const width = isNumeric(this.width) ? this.width + 'px' : this.width;
    const height = isNumeric(this.height) ? this.height + 'px' : this.height;

    return toStyleVal([
      ['background', color],
      ['min-width', width],
      ['min-height', height]
    ]);
  }

  attrVal(idx: number) {
    const color = idx === this.active ? 'rgba(0, 0, 0, 0.35)' : 'rgba(0, 0, 0, 0)';

    return {
      width: '100%',
      height: '100%',
      big: true,
      color
    };
  }
}
